import React from "react";
import Communication from ".";
import CommunicationEvent from "./CommunicationEvent";

export const communicationRoute = (data) => [
  {
    path: "/:lang/user/communication",
    title: "chat",
    layout: data?.user?.role === "organization" ? "user" : "front",
    routeType: ["user", "organization"].includes(data?.user?.role)
      ? data?.user?.role
      : "user",
    component: Communication,
  },
  {
    path: "/:lang/user/communication/:eventId",
    title: "chat",
    layout: "frontUserInner",
    routeType: "organization",
    component: CommunicationEvent,
  },
];
